var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.messages)?_c('span',{staticClass:"buttonAddNebenbewerbungHinzufuegenWrapper"},[(_vm.showButton)?_c('button',{staticClass:"button primary mt-1",attrs:{"type":"button"},on:{"click":function($event){return _vm.addNebenbewerbung()}}},[_vm._v(" "+_vm._s(_vm.messages['fh.bewerbung.nebenbewerbungHinzufuegen'])+" ")]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }